import React from "react";
import LinkItems from "./TopLinkItems";
import styled from "@emotion/styled";

const TopRow = styled.div`
    display: flex;
    gap: 1.5rem;
    align-items: center;
    justify-content: flex-end;
    margin-top: 0.3rem;
`;

const NavTopRow = ({ nav, organization }: { nav: any; organization: any }) => {
    return (
        <TopRow>
            <LinkItems sections={nav.sections} organization={organization} />
        </TopRow>
    );
};

export default NavTopRow;
